function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLanguageMenuToggle = function SvgLanguageMenuToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5 27",
    width: 5,
    height: 27,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    style: {
      fill: "rgb(82, 82, 82)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 5,
    height: 5,
    style: {
      fill: "rgb(82, 82, 82)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 22,
    width: 5,
    height: 5,
    style: {
      fill: "rgb(82, 82, 82)"
    }
  }));
};
export default SvgLanguageMenuToggle;